import { FunctionComponent } from 'react'
import { TableCell } from '@black-bear-energy/rucksack'

export const TableCellWithDefault: FunctionComponent<
  TableCellWithDefaultProps
> = ({ children, defaultValue = '—' }) => {
  return <TableCell>{children || defaultValue}</TableCell>
}

interface TableCellWithDefaultProps {
  children: React.ReactNode
  defaultValue?: string
}
